import http from "../../../services/http";
import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";

import {
  IAPI_REC003_Request,
  IAPI_REC003_Response,
  IAPI_REC004_Request,
  IAPI_REC004_Response,
  IAPI_REC018_Request,
  IAPI_REC018_Response,
} from "../../../type/apiType";

// 送金一覧表示API
const httpIAPI_REC003 = async (
  param: IAPI_REC003_Request
): Promise<IAPI_REC003_Response> => {
  const res = await http.post(ApiUrl.API_REC003, {
    ...param,
  });
  return res.data;
};

// 振込データ参照API
const httpIAPI_REC004 = async (
  param: IAPI_REC004_Request
): Promise<IAPI_REC004_Response> => {
  const res = await http.post(ApiUrl.API_REC004, {
    ...param,
  });
  return res.data;
};

// 振込データのダウンロードAPI
const httpIAPI_REC018 = async (
  param: IAPI_REC018_Request
): Promise<IAPI_REC018_Response> => {
  const res = await http.post(ApiUrl.API_REC018, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_REC003, httpIAPI_REC004, httpIAPI_REC018 };
